import styled from "styled-components";

export const Container = styled.div`

    button {
        font-family: var(--font-body);
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        border-radius: 10px;
        color: var(--action-link);
    }
`;